<template>
    <div class="content container-fluid">
        <!-- Begin: Popover for Filter -->
        <popover name="popDelegator" :pointer="false" style="width: 30em; margin-left: -5em">
            <multiselect v-model="searchColFilter.tranDelegator" :options="colFilter.tranDelegatorColFilter"
                :multiple="true"></multiselect>
        </popover>
        <popover name="popDelegatee" :pointer="false" style="width: 30em; margin-left: -5em">
            <multiselect v-model="searchColFilter.tranDelegatee" :options="colFilter.tranDelegateeColFilter"
                :multiple="true"></multiselect>
        </popover>
        <popover name="popDateStart" :pointer="false" style="width: 30em; margin-left: -5em">
            <multiselect v-model="searchColFilter.tranDateStart" :options="colFilter.tranDateStartColFilter"
                :multiple="true"></multiselect>
        </popover>
        <popover name="popDateEnd" :pointer="false" style="width: 30em; margin-left: -5em">
            <multiselect v-model="searchColFilter.tranDateEnd" :options="colFilter.tranDateEndColFilter" :multiple="true">
            </multiselect>
        </popover>
        <popover name="popWorkflowType" :pointer="false" style="width: 30em; margin-left: -5em">
            <multiselect v-model="searchColFilter.tranWorkflowType" :options="colFilter.tranWorkflowTypeColFilter"
                :multiple="true"></multiselect>
        </popover>
        <!-- End: Popover for Filter -->

        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Delegation</h3>
                </div>
                <div class="col-auto float-right ml-auto">
                    <button class="btn add-btn" @click="$router.push({ name: 'delegationAdd' })">
                        <i class="fa fa-plus"></i>New Delegation
                    </button>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Table List -->
        <div class="row mt-2">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                    <table class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th>Action</th>
                                <th>
                                    <i class="fa fa-filter" v-popover:popDelegator v-if="colFilter" :style="[
                                        searchColFilter.tranDelegator.length > 0
                                            ? { color: 'orange' }
                                            : { color: 'white' },
                                    ]"></i>
                                    <button class="btn p-0" @click="setSortBy('delegator')">
                                        Delegator
                                        <span class="tableHeaderSortIcon">
                                            <i class="fa fa-long-arrow-up ml-3" :style="[
                                                paging.SortBy === 'delegator'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i>
                                            <i class="fa fa-long-arrow-down" :style="[
                                                paging.SortBy === 'delegator_desc'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i></span>
                                    </button>
                                </th>
                                <th>
                                    <i class="fa fa-filter" v-popover:popDelegatee v-if="colFilter" :style="[
                                        searchColFilter.tranDelegatee.length > 0
                                            ? { color: 'orange' }
                                            : { color: 'white' },
                                    ]"></i>
                                    <button class="btn p-0" @click="setSortBy('delegatee')">
                                        Delegatee
                                        <span class="tableHeaderSortIcon">
                                            <i class="fa fa-long-arrow-up ml-3" :style="[
                                                paging.SortBy === 'delegatee'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i>
                                            <i class="fa fa-long-arrow-down" :style="[
                                                paging.SortBy === 'delegatee_desc'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i></span>
                                    </button>
                                </th>
                                <th>
                                    <i class="fa fa-filter" v-popover:popDateStart v-if="colFilter" :style="[
                                        searchColFilter.tranDateStart.length > 0
                                            ? { color: 'orange' }
                                            : { color: 'white' },
                                    ]"></i>
                                    <button class="btn p-0" @click="setSortBy('dateStart')">
                                        Date Start
                                        <span class="tableHeaderSortIcon">
                                            <i class="fa fa-long-arrow-up ml-3" :style="[
                                                paging.SortBy === 'dateStart'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i>
                                            <i class="fa fa-long-arrow-down" :style="[
                                                paging.SortBy === 'dateStart_desc'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i></span>
                                    </button>
                                </th>
                                <th>
                                    <i class="fa fa-filter" v-popover:popDateEnd v-if="colFilter" :style="[
                                        searchColFilter.tranDateEnd.length > 0
                                            ? { color: 'orange' }
                                            : { color: 'white' },
                                    ]"></i>
                                    <button class="btn p-0" @click="setSortBy('dateEnd')">
                                        Date End
                                        <span class="tableHeaderSortIcon">
                                            <i class="fa fa-long-arrow-up ml-3" :style="[
                                                paging.SortBy === 'dateEnd'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i>
                                            <i class="fa fa-long-arrow-down" :style="[
                                                paging.SortBy === 'dateEnd_desc'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i></span>
                                    </button>
                                </th>
                                <th>
                                    <i class="fa fa-filter" v-popover:popWorkflowType v-if="colFilter" :style="[
                                        searchColFilter.tranWorkflowType.length > 0
                                            ? { color: 'orange' }
                                            : { color: 'white' },
                                    ]"></i>
                                    <button class="btn p-0" @click="setSortBy('workflowType')">
                                        Workflow Types
                                        <span class="tableHeaderSortIcon">
                                            <i class="fa fa-long-arrow-up ml-3" :style="[
                                                paging.SortBy === 'workflowType'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i>
                                            <i class="fa fa-long-arrow-down" :style="[
                                                paging.SortBy === 'workflowType_desc'
                                                    ? { color: 'orange' }
                                                    : { color: 'white' },
                                            ]"></i></span>
                                    </button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in records" :key="item.Id">
                                <td>
                                    <router-link class="btn" title="Edit" :to="{
                                        name: 'delegationEdit',
                                        params: { id: item.Id },
                                    }">
                                        <i class="fa fa-edit"></i>
                                    </router-link>
                                    <button class="btn" title="Delete" @click="remove(item.Id)">
                                        <i class="fa fa-trash-o"></i>
                                    </button>
                                </td>
                                <td>{{ item.Delegator }}</td>
                                <td>{{ item.Delegatee }}</td>
                                <td>{{ item.DateStartDisplay }}</td>
                                <td>{{ item.DateEndDisplay }}</td>
                                <td>{{ item.WorkflowTypesDisplay }}</td>
                            </tr>
                            <tr v-if="records && !records.length">
                                <td colspan="6" class="text-center">{{ this.noRecordText }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Table List -->

        <!--Pagination -->
        <div class="row mb-4" v-if="records && records.length">
            <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
                Showing
                {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
                to
                {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    records.length
                }}
                of {{ totalRecords }} entries
            </div>

            <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
                <div class="navbar justify-content-end">
                    <button v-on:click="first()" v-if="paging.CurrentPage != 1" class="btn btn-white">
                        First
                    </button>
                    <button v-on:click="prev()" class="btn btn-white ml-1 mr-3" v-if="paging.CurrentPage > 1">
                        Prev
                    </button>
                    Page
                    <input class="form-control form-control-sm mx-1" type="number" step="1" min="1" :max="paging.TotalPage"
                        v-model="paging.CurrentPage" @change="onCurrentPageChange($event)" style="width: 4rem" />

                    <span>of {{ paging.TotalPage }}</span>
                    <button v-on:click="next()" class="btn btn-white ml-3 mr-1"
                        v-if="paging.CurrentPage < paging.TotalPage">
                        Next
                    </button>
                    <button v-on:click="last()" v-if="paging.CurrentPage != paging.TotalPage" class="btn btn-white">
                        Last
                    </button>
                </div>
            </div>
        </div>
        <!--/Pagination -->
    </div>
</template>

<script>
import API from "../../../http-common.js";
import Multiselect from "vue-multiselect";
import config from "../../../config.js";

export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            records: null,
            noRecordText: config.NO_RECORD_TEXT,
            //for pagination
            searchColFilter: {
                tranDelegator: [],
                tranDelegatee: [],
                tranDateStart: [],
                tranDateEnd: [],
                tranWorkflowType: []
            },
            colFilter: {},
            paging: {
                Search: "",
                CurrentPage: 1,
                TotalPage: "",
                SizePerPage: 20,
                Sizes: [5, 10, 20, 100],
                SortBy: "",
            },
            totalRecords: "",
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        isManager() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.IsManager;
        },
        searchFilter() {
            return [
                { name: "tranDelegator", val: this.searchColFilter.tranDelegator },
                { name: "tranDelegatee", val: this.searchColFilter.tranDelegatee },
                { name: "tranDateStart", val: this.searchColFilter.tranDateStart },
                { name: "tranDateEnd", val: this.searchColFilter.tranDateEnd },
                { name: "tranWorkflowType", val: this.searchColFilter.tranWorkflowType },
            ];
        },
    },

    watch: {
        "searchColFilter.tranDelegator": function (val, oldVal) {
            this.getDelegations();
        },
        "searchColFilter.tranDelegatee": function (val, oldVal) {
            this.getDelegations();
        },
        "searchColFilter.tranDateStart": function (val, oldVal) {
            this.getDelegations();
        },
        "searchColFilter.tranDateEnd": function (val, oldVal) {
            this.getDelegations();
        },
        "searchColFilter.tranWorkflowType": function (val, oldVal) {
            this.getDelegations();
        },
        "paging.Search": function (val, oldVal) {
            this.getDelegations();
        },
        "paging.SizePerPage": function (val, oldVal) {
            this.paging.CurrentPage = 1;
            this.getDelegations();
        },
        "paging.CurrentPage": function (val, oldVal) {
            if (val > this.paging.TotalPage) {
                this.paging.CurrentPage = this.paging.TotalPage;
            }
        },
    },

    methods: {
        remove(id) {
            let param = {
                Token: this.token,
                Id: id,
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to delete the record?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willDelete) => {
                if (willDelete) {
                    this.$store.state.isLoading = true;
                    API.deleteDelegation(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.getDelegations();
                            }
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        },
        getDelegations() {
            let param = {
                Token: this.token,
                Search: this.paging.Search,
                CurrentPage: this.paging.CurrentPage,
                TotalPage: this.paging.TotalPage,
                SizePerPage: this.paging.SizePerPage,
                SortBy: this.paging.SortBy,
                searchFilter: this.searchFilter,
            };
            this.$store.state.isLoading = true;
            API.getDelegations(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.records = response.data.record;
                        this.totalRecords = response.data.total;
                        this.paging.TotalPage = response.data.pageCount;
                        this.colFilter = response.data.colFilter;
                        if (this.paging.CurrentPage > this.paging.TotalPage) {
                            this.paging.CurrentPage = 1;
                        }
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },

        //pagination method
        onCurrentPageChange(event) {
            let currentPage = event.target.value;
            if (currentPage < 1) {
                currentPage = 1;
            }
            this.paging.CurrentPage = parseInt(currentPage);
            this.getDelegations();
        },
        first() {
            this.paging.CurrentPage = 1;
            this.getDelegations();
        },
        prev() {
            this.paging.CurrentPage -= 1;
            this.getDelegations();
        },
        next() {
            this.paging.CurrentPage += 1;
            this.getDelegations();
        },
        last() {
            this.paging.CurrentPage = this.paging.TotalPage;
            this.getDelegations();
        },
        setSortBy(payload) {
            switch (payload) {
                case "delegator":
                    if (this.paging.SortBy === "delegator") {
                        this.paging.SortBy = "delegator_desc";
                    } else if (this.paging.SortBy === "delegator_desc") {
                        this.paging.SortBy = "delegator";
                    } else {
                        this.paging.SortBy = "delegator";
                    }
                    break;
                case "delegatee":
                    if (this.paging.SortBy === "delegatee") {
                        this.paging.SortBy = "delegatee_desc";
                    } else if (this.paging.SortBy === "delegatee_desc") {
                        this.paging.SortBy = "delegatee";
                    } else {
                        this.paging.SortBy = "delegatee";
                    }
                    break;
                case "name":
                    if (this.paging.SortBy === "name") {
                        this.paging.SortBy = "name_desc";
                    } else if (this.paging.SortBy === "name_desc") {
                        this.paging.SortBy = "name";
                    } else {
                        this.paging.SortBy = "name";
                    }
                    break;
                case "dateStart":
                    if (this.paging.SortBy === "dateStart") {
                        this.paging.SortBy = "dateStart_desc";
                    } else if (this.paging.SortBy === "dateStart_desc") {
                        this.paging.SortBy = "dateStart";
                    } else {
                        this.paging.SortBy = "dateStart";
                    }
                    break;
                case "dateEnd":
                    if (this.paging.SortBy === "dateEnd") {
                        this.paging.SortBy = "dateEnd_desc";
                    } else if (this.paging.SortBy === "dateEnd_desc") {
                        this.paging.SortBy = "dateEnd";
                    } else {
                        this.paging.SortBy = "dateEnd";
                    }
                    break;
                case "workflowType":
                    if (this.paging.SortBy === "workflowType") {
                        this.paging.SortBy = "workflowType_desc";
                    } else if (this.paging.SortBy === "workflowType_desc") {
                        this.paging.SortBy = "workflowType";
                    } else {
                        this.paging.SortBy = "workflowType";
                    }
                    break;
            }
            this.getDelegations();
        },
    },

    created() {
        this.getDelegations();
        //access control
        if (this.role != "admin" && !this.isManager)
            this.$router.replace({ name: "home" });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/System/Delegation/DelegationList.vue